import { render, staticRenderFns } from "./IndexValuation.vue?vue&type=template&id=c4fe7a56&"
import script from "./IndexValuation.vue?vue&type=script&lang=js&"
export * from "./IndexValuation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports